
(function() {
  function initParallax() {
    var section = document.querySelector('[id*="slideshow_mAY6gk"]');
    if (!section) return;
    
    var images = section.querySelectorAll('slideshow-slides img, slideshow-slides video');
    if (!images.length) return;
    
    function updateParallax() {
      var rect = section.getBoundingClientRect();
      var windowH = window.innerHeight;
      
      // Only apply when section is in viewport
      if (rect.bottom < 0 || rect.top > windowH) return;
      
      // Calculate scroll progress: 0 when section enters from bottom, 1 when exits top
      var progress = (windowH - rect.top) / (windowH + rect.height);
      // Parallax offset: moves image from -30px to +30px
      var offset = (progress - 0.5) * 60;
      
      images.forEach(function(img) {
        img.style.transform = 'translateY(' + offset + 'px)';
      });
    }
    
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
